import { type ComponentProps } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { type Option } from "../inputs/select/types";

interface Props<T> extends ComponentProps<"button"> {
  option: Option<T>;
  selected?: boolean;
  className?: string;
}

export const OptionItem = <T,>({
  option,
  selected,
  className,
  ...props
}: Props<T>) => {
  const disabled = props.disabled || option.disabled;

  return (
    <button
      className={twMerge(
        "w-full h-8 px-4 flex items-center gap-2 text-xs cursor-pointer rounded text-v2-primary",
        clsx({
          "hover:bg-v2-action-tertiary": !disabled,
          "text-v2-disabled bg-v2-primary cursor-auto": disabled,
          "bg-v2-action-secondary font-semibold hover:bg-v2-action-secondary":
            selected,
        }),
        className,
      )}
      {...props}
    >
      <span className="truncate">{option.label}</span>
    </button>
  );
};
